// @ts-nocheck
import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

const StartTopPanel = () => (
    <section className='start-top-panel'>
        <div className='start-top-panel-overlay'>
            <div className='start-top-panel-content'>
                <div className='row'>
                    <div className='col-lg-7 col-md-8 col-sm-10'>
                        <p className='start-top-panel-eyebrow'>MAN DRIVER APP</p>
                        <h1>
                            <FormattedMessage id='intl-msg:startpage.preDepartureCheckPanel.title' />
                        </h1>
                        <p className='start-top-panel-copy text-size-large text-wrap-balance'>
                            <FormattedMessage
                                id='intl-msg:startpage.preDepartureCheckPanel.description.driver'
                                values={{ strong: chunks => <strong>{chunks}</strong> }}
                            />
                            <br />
                            <FormattedMessage
                                id='intl-msg:startpage.preDepartureCheckPanel.description.results'
                                values={{ strong: chunks => <strong>{chunks}</strong> }}
                            />
                            <br />
                            <br />
                            <FormattedMessage
                                id='intl-msg:startpage.preDepartureCheckPanel.description.serviceCare'
                                values={{ strong: chunks => <strong>{chunks}</strong> }}
                            />
                        </p>
                        <Button
                            as='a'
                            href='#/table'
                            bsStyle={Button.SECONDARY}
                            bsSize={Button.LG}
                            className='start-top-panel-action'
                            iconName='icon-chevron-right'
                            iconRight
                        >
                            <FormattedMessage id='intl-msg:startpage.preDepartureCheckPanel.getStarted' />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default StartTopPanel;
